/**
 * BFF tenant hashtags — Admin / Core proxy (`/api/tenant/hashtags`). ADMIN only.
 *
 * Analytics catalog (dropdown): GET /catalog/{tenant}/hashtag-campaigns (ver hashtagCatalogAnalyticsService)
 */
export const hashtagApiPaths = {
  list: '/api/tenant/hashtags',
  create: '/api/tenant/hashtags/campaigns',
  scrapeCampaign: (campaignCode: string) =>
    `/api/tenant/hashtags/campaigns/${encodeURIComponent(campaignCode)}/scrape`,
  campaignSettings: (campaignCode: string) =>
    `/api/tenant/hashtags/campaigns/${encodeURIComponent(campaignCode)}/settings`,
  platformStatus: (hashtagId: string) =>
    `/api/tenant/hashtags/${encodeURIComponent(hashtagId)}/status`,
} as const;

/** @deprecated Use `hashtagApiPaths.create` */
export const HASHTAG_CAMPAIGNS_REGISTER_PATH = hashtagApiPaths.create;
